export const SORT_ORDER = {
    DESC: 'desc',
    ASC: 'asc',
}